module.exports = __webpack_public_path__ + "img/Male-inactive.202a4536.svg";